import React from 'react'
import useIsAnalyticsV2Avail from '@page-components/AnalyticsV2/hooks/useIsAnalyticsV2Available'
import TrackPurchase from '@page-components/AnalyticsV2/tracking-components/TrackPurchase'

import PendingPaymentRequests from './PendingPaymentRequest'
import Track from './Track'

export default function Other() {
  const isAnalyticsV2Avail = useIsAnalyticsV2Avail()
  return (
    <>
      <PendingPaymentRequests />
      {!isAnalyticsV2Avail && <Track />}
      {isAnalyticsV2Avail && <TrackPurchase />}
    </>
  )
}
